export const defaultConfigs = {
    title: '',
    successUrl: '/',
    buttonText: 'Save Password',
    headingSize: 'h4',
};
